import React, { useState, useEffect } from 'react'
import { Rings } from 'react-loader-spinner'
import { useDispatch } from 'react-redux';
import { Container, Row, Col, Card, Image, Spinner } from 'react-bootstrap'

import { usersService } from '../../../_services/users.service';
import { alertActions } from '../../../_actions/alert.actions';
import { authenticationActions } from '../../../_actions/authentication.actions';
import { authenticationService } from '../../../_services/authentication.service';
import { clientActions } from '../../../_actions/client.actions';
import { userService } from '../../../_services/user.service';
import { userActions } from '../../../_actions/user.actions';

export default function UserConfirm({ history, match }) {
  const dispatch = useDispatch();

  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    usersService.getSetupToken(match.params.token)
      .then(data => {
        setLoading(false)
        setData(data)

        let accessToken;

        usersService.confirmAccount(match.params.token)
          .then(setupData => {        
            accessToken = setupData.accessToken;
            
            dispatch(authenticationActions.setToken(setupData.accessToken))
    
            return authenticationService.refresh(setupData.providerId, setupData.accessToken)
          })
          .then(clientData => {
            dispatch(clientActions.setAccount(clientData));
    
            return userService.me(accessToken);
          })
          .then(userData => {
            dispatch(userActions.setCurrentUser(userData));
            dispatch(authenticationActions.setPermissions(userData.permissions));
    
            history.push('/dashboard', { welcome: true })
          })
      })
      .catch(() => {
        history.push('/login')

        dispatch(alertActions.error('Your setup token was not found. Please contact the account holder.'))
      })
  }, [dispatch, history, match.params.token]);

  if (loading) {
    return <Spinner animation='border' />
  }

  return (
    <Container>
      <Row className='mt-4'>
        <Col xs='3'>
        { data.providerLogo &&
          <Row>
            <Col>
              <Image src={data.providerLogo}  fluid /> 
            </Col>
          </Row>
        } 
          <br />
          <Row>
            <Col>
              <h5 className='font-weight-normal'>Hello, { data.firstName } { data.lastName }</h5>
            </Col>
          </Row>
          <br />
          <Row>
            <Col>
              <p>{ data.providerName } is using AxS Health to improve patient communication. </p>
              <br />
              <p>With your AxS account, you'll be able to send patient forms, schedule telehealth appointments, and send patient messages.</p>
            </Col>
          </Row>
        </Col>
        <Col className='px-0'>
          <Card style={{ height: '741px' }}>
            <Card.Body >
              <Row className='h-100'>
                <Col className='text-center' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'stretch' }}>
                  <Rings height='200' width='200' color='#1AB2E9' arialLabel="loading-indicator" wrapperStyle={{ justifyContent: 'center' }} />
                  <br />
                  <h1 className='pb-5 font-weight-light'>Setting up your account...</h1>
                  <p>One moment please.</p>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}